import { ApiCaller } from 'apis/ApiCaller';
import { Success } from 'types';

export type PendingOrder = {
	Comment: string;
	DateCreate: string;
	ID: number;
	LicenseId: number;
	LicenseName: string;
	NumRequested: number;
	OrderChain: OrderChainItem[];
	PartnerName: string;
	PurchaseOrder: string;
	RenewedByOrderControl: string | null;
	RequestedUserFirstName: string;
	RequestedUserLastName: string;
};

export type OrderChainItem = {
	ID: number;
	PartnerName: string;
	PartnerType: string;
	RenewedByOrderControl: string | null;
};

export type PendingOrderInventory = {
	Inventory: number;
	LicenseID: number;
};

export class PendingOrdersApi {

    private static apiCaller = new ApiCaller('PendingOrders');

    public static GetPendingOrders(partnerId: number): Promise<PendingOrder[]> {

	    return this.apiCaller.GET<PendingOrder[]>('GetPendingOrders', { partnerId });

    }

    public static GetInventory(partnerId: number): Promise<PendingOrderInventory[]> {

	    return this.apiCaller.GET<PendingOrderInventory[]>('GetInventory', { partnerId });

    }

    public static CancelOrders(orderIds: number[], comments: string[]): Promise<Success<void>[]> {

	    return this.apiCaller.POST<Success<void>[]>('CancelOrders', { comments, orderIds });

    }

    public static FillWithInventory(partnerId: number, orderIds: number[], licenseIds: number[], numRequested: number[], purchaseOrders: string[], comments: string[]): Promise<Success<void>[]> {

	    return this.apiCaller.POST<Success<void>[]>('FillWithInventory', { comments, licenseIds, numRequested, orderIds, partnerId, purchaseOrders });

    }

    public static AutofillOrders(partnerId: number, orderIds: number[], licenseIds: number[], numRequested: number[], purchaseOrders: string[], comments: string[]): Promise<Success<void>[]> {

	    return this.apiCaller.POST<Success<void>[]>('AutofillOrders', { comments, licenseIds, numRequested, orderIds, partnerId, purchaseOrders });

    }

}
